<app-really-simple-syndication-feed-reader
	[feedSourceUrl]="context.data.feedSourceUrl">
</app-really-simple-syndication-feed-reader>